// apps/web/src/auth/require-auth.ts
// TanStack Router beforeLoad guard helper — probes GET /api/auth/me and
// throws redirect({ to: '/sign-in' }) on 401. Per Plan §4.7.10 carry-
// forward #2 + Brief §10 auth flow step 0 (post-Brief-Revision).
//
// Per feedback_no_fallbacks: network errors throw (TanStack Router shows
// error boundary). Silent-allow on network failure = security hole;
// silent-deny on transient = user lockout. Surface explicitly.

import { redirect } from '@tanstack/react-router';

// Empty default = relative path = same-origin via Pages Function proxy
// (Step 22.E-prime-2 2026-05-18 — first-party cookie posture).
const API_BASE = import.meta.env.VITE_API_URL ?? '';

export async function requireAuth(): Promise<void> {
  const res = await fetch(`${API_BASE}/api/auth/me`, {
    credentials: 'include',
  });

  if (res.status === 401) {
    throw redirect({ to: '/sign-in' });
  }

  if (!res.ok) {
    throw new Error(`Auth probe failed: HTTP ${res.status}`);
  }

  // 200 — valid session; allow route to load
}
